import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinchennai() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Chennai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Chennai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Chennai, catering to the transportation needs of IT parks, corporate offices, business centers, and industrial hubs across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Chennai.',

    top: 'Top Places to Visit in Chennai with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is Chennai’s iconic shoreline and one of the longest urban beaches in the world. Stretching over 13 km along the Bay of Bengal, it attracts locals and tourists for morning walks, jogging, kite flying, and enjoying street food like sundal and murukku. The beach comes alive during festivals and evening gatherings, making it a central hub for leisure and cultural activities."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple, located in Mylapore, is a historic Dravidian-style temple dedicated to Lord Shiva. Known for its colorful gopuram, intricate sculptures, and serene inner sanctum, the temple is a spiritual and architectural gem. Devotees and visitors come to witness daily rituals, festivals, and the vibrant cultural atmosphere surrounding the temple complex."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British East India Company, is a historic landmark and administrative center. The fort houses the Tamil Nadu Legislative Assembly, St. Mary’s Church, and a museum displaying artifacts from the colonial era. Visitors can explore its ramparts, bastions, and exhibits to get a glimpse of Chennai’s colonial history and military architecture."
  },
  {
    "title": "Santhome Cathedral Basilica",
    "description": "Santhome Cathedral Basilica is a beautiful Gothic-style church built over the tomb of St. Thomas, one of the twelve apostles of Jesus. The church features elegant stained-glass windows, intricate interiors, and a peaceful ambiance. It is a major pilgrimage site and also attracts tourists interested in religious architecture and Chennai’s Christian heritage."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of India’s smallest national parks, located within the city limits of Chennai. It houses a variety of wildlife including deer, blackbucks, and exotic bird species. The park also contains the Snake Park and Children’s Park, making it ideal for families, nature lovers, and educational visits. Its green trails provide a refreshing escape from the urban environment."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a monument dedicated to the Tamil poet and philosopher Thiruvalluvar. The structure features a grand chariot-shaped auditorium and intricate stone carvings depicting his literary works. It serves as a cultural landmark, attracting visitors interested in Tamil literature, history, and architectural artistry."
  },
  {
    "title": "Elliot’s Beach",
    "description": "Elliot’s Beach, located in Besant Nagar, is a quieter alternative to Marina Beach. It is popular for evening walks, jogging, and serene sunset views. The beach is also dotted with local cafés and eateries, making it a favorite hangout for families, couples, and youth seeking a relaxed seaside experience away from the city’s hustle and bustle."
  },
  {
    "title": "Theosophical Society",
    "description": "The Theosophical Society in Adyar is a sprawling campus featuring lush gardens, century-old trees, and historical buildings. It is a center for spiritual study and meditation and houses rare plant species and the famous Adyar Banyan Tree. Visitors can enjoy peaceful walks, birdwatching, and exploring the serene environment that reflects Chennai’s cultural and philosophical heritage."
  },
  {
    "title": "Chennai Rail Museum",
    "description": "The Chennai Rail Museum showcases the history and evolution of railways in India. It features vintage locomotives, carriages, photographs, and interactive exhibits. Visitors, especially families and students, can explore miniature train rides, learn about railway technology, and engage with the history of Indian Railways in an educational and entertaining setting."
  },
  {
    "title": "Semmozhi Poonga",
    "description": "Semmozhi Poonga is a botanical garden in central Chennai, featuring themed gardens, landscaped lawns, walking paths, and exotic plant species. It is ideal for morning walks, photography, and leisure outings with family or friends. The park’s aesthetic layout and peaceful environment provide a green retreat amid Chennai’s urban landscape."
  }
],


"services": [
{
"name": "Chennai Corporate Transport",
"description": "Chennai Corporate Transport offers end-to-end workforce mobility solutions for companies, IT parks, and industrial zones in Chennai. The service includes structured daily routes, real-time vehicle tracking, professional drivers, and GPS-enabled navigation to ensure safe, timely, and efficient employee commutes. Designed for companies of all sizes, it also supports multi-shift operations, flexible scheduling, and bulk staff transportation while maintaining high safety and comfort standards."
},
{
"name": "Employee Shuttle Chennai",
"description": "Employee Shuttle Chennai provides dedicated shuttle services for office staff, IT park employees, and corporate teams. With air-conditioned minibuses and vans, the service ensures optimized multi-route planning, punctual pick-ups and drops, trained chauffeurs, and real-time tracking. It is ideal for large companies and factories seeking organized and reliable employee transport solutions within Chennai."
},
{
"name": "Business Cab Chennai",
"description": "Business Cab Chennai delivers premium corporate travel solutions for meetings, client visits, airport transfers, and inter-office mobility. Equipped with well-maintained sedans and SUVs, professional drivers, and GPS-enabled monitoring, the service ensures punctual, safe, and comfortable travel for executives and employees across Chennai."
},
{
"name": "Staff Pickup Drop Chennai",
"description": "Staff Pickup Drop Chennai provides structured daily commute services for office and industrial employees. The service offers fixed and flexible routes, multi-shift support, trained drivers, and real-time vehicle monitoring to ensure safe, efficient, and reliable transportation for staff within the city and surrounding areas."
},
{
"name": "Monthly Cab Chennai",
"description": "Monthly Cab Chennai offers long-term cab rental solutions for companies requiring consistent employee transportation. The service includes dedicated vehicles, professional drivers, GPS tracking, flexible monthly plans, and end-to-end fleet management to ensure uninterrupted, safe, and cost-effective daily commutes for corporate staff."
},
{
"name": "Best Corporate Cabs Chennai",
"description": "Best Corporate Cabs Chennai provides top-tier corporate mobility services with premium sedans and SUVs, trained chauffeurs, high safety standards, and professional service. Ideal for executives, managers, and business visitors, it ensures a seamless and comfortable travel experience for corporate needs across Chennai."
},
{
"name": "Affordable Office Cab Chennai",
"description": "Affordable Office Cab Chennai delivers budget-friendly employee transportation solutions without compromising safety or comfort. Designed for SMEs and startups, the service includes optimized routes, clean vehicles, professional drivers, and reliable daily commute operations for corporate staff."
},
{
"name": "Outstation Cab Chennai",
"description": "Outstation Cab Chennai offers long-distance corporate travel solutions for business trips, client visits, and intercity employee mobility. With sedans and SUVs equipped with GPS tracking, experienced chauffeurs, and planned routes, it ensures safe, comfortable, and punctual travel for staff traveling outside Chennai."
},
{
"name": "Sedan Cab Chennai",
"description": "Sedan Cab Chennai provides premium sedan vehicles for executives, managers, and corporate visitors. Each vehicle is professionally maintained, comfortable, and operated by trained drivers to ensure a smooth, safe, and luxurious commute for business travel, office runs, and airport transfers."
},
{
"name": "SUV Cab Chennai",
"description": "SUV Cab Chennai offers spacious and comfortable SUVs suitable for team travel, senior executive transport, industrial visits, and long-distance corporate trips. The service includes GPS-enabled vehicles, professional drivers, and enhanced safety measures for reliable and premium corporate mobility."
},
{
"name": "Company Staff Transport Chennai",
"description": "Company Staff Transport Chennai specializes in large-scale workforce mobility solutions for corporate offices, factories, and IT parks. It includes organized routing, shift-based scheduling, trained drivers, vehicle maintenance, and real-time tracking to ensure safe and efficient employee transport across the city."
},
{
"name": "Corporate Fleet Chennai",
"description": "Corporate Fleet Chennai provides fleet outsourcing and management services for companies requiring multiple vehicles for employee commute, executive travel, and bulk transportation. The service includes sedans, SUVs, shuttle vans, professional drivers, GPS tracking, and maintenance support for reliable corporate mobility."
},
{
"name": "IT Park Cab Chennai",
"description": "IT Park Cab Chennai offers dedicated transport solutions for IT professionals commuting to major IT parks across the city. The service provides optimized routes, trained drivers, air-conditioned vehicles, multi-shift support, and real-time tracking to ensure safe, efficient, and comfortable daily travel."
},
{
"name": "Airport Corporate Cab Chennai",
"description": "Airport Corporate Cab Chennai delivers professional airport transfer solutions for employees, executives, and clients. The service includes punctual pickups, comfortable sedans and SUVs, trained chauffeurs, GPS tracking, and corporate billing, ensuring reliable and smooth airport connectivity."
},
{
"name": "Chauffeur Service Chennai",
"description": "Chauffeur Service Chennai provides professionally trained drivers for corporate executives, senior management, and business visitors. The service ensures safe, punctual, and comfortable travel for office commutes, client meetings, airport transfers, and outstation trips, backed by GPS-enabled vehicles and strict safety protocols."
}
],

"tableData": [
["Chennai Corporate Transport", "Employee Shuttle Chennai"],
["Business Cab Chennai", "Staff Pickup Drop Chennai"],
["Monthly Cab Chennai", "Best Corporate Cabs Chennai"],
["Affordable Office Cab Chennai", "Outstation Cab Chennai"],
["Sedan Cab Chennai", "SUV Cab Chennai"],
["Company Staff Transport Chennai", "Corporate Fleet Chennai"],
["IT Park Cab Chennai", "Airport Corporate Cab Chennai"],
["Chauffeur Service Chennai", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Chennai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Chennai, ensuring smooth and efficient transportation for employees and business executives across the city."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Chennai’s business districts, IT parks, and industrial zones, helping employees reach work or meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Chennai."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]


































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Chennai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees across Chennai.',
  },
  {
    question: 'What types of corporate cab services are available in Chennai?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet management for businesses.',
  },
  {
    question: 'Do you support daily commuting for employees in Chennai?',
    answer: 'Yes, we provide structured daily commute services with punctual pickups, smart route planning, and multi-shift transportation for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Chennai?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate travel in Chennai?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on corporate requirements.',
  },
  {
    question: 'Do you provide long-term corporate cab contracts in Chennai?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and transparent terms.',
  },
  {
    question: 'Are your corporate cabs equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you manage multi-shift employee transportation in Chennai?',
    answer: 'Yes, we support early morning, night, weekend, and rotational shifts for corporate employees across Chennai.',
  },
  {
    question: 'What payment modes are available for corporate cab services in Chennai?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aravind Kumar',
    feedback: 'Highly reliable corporate cab service in Chennai. Punctual, safe, and professional drivers for our employees.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Ramesh',
    feedback: 'Excellent corporate transportation service. Vehicles are clean, well-maintained, and perfect for daily employee commuting.',
    rating: 5,
  },
];




































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Chennai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-chennai.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services in Chennai, including employee shuttles, business cabs, staff pickup & drop, monthly cab plans, IT park transport, airport corporate transfers, chauffeur-driven executive vehicles, and corporate fleet solutions for companies operating in Chennai.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-chennai"
  }
};






  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Chennai | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Chennai including employee shuttles, business cabs, staff pickup & drop, monthly cab plans, IT park transport, airport corporate transfers, and chauffeur-driven vehicles."
  />

  <meta
    name="keywords"
    content="Chennai Corporate Transport, Employee Shuttle Chennai, Business Cab Chennai, Staff Pickup Drop Chennai, Monthly Cab Chennai, Best Corporate Cabs Chennai, Affordable Office Cab Chennai, Outstation Cab Chennai, Sedan Cab Chennai, SUV Cab Chennai, Company Staff Transport Chennai, Corporate Fleet Chennai, IT Park Cab Chennai, Airport Corporate Cab Chennai, Chauffeur Service Chennai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinchennai;